import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "send_otp_container"
}
const _hoisted_2 = { class: "method_selection" }
const _hoisted_3 = { class: "method_title" }
const _hoisted_4 = { class: "method_title" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }

import { ref, watch, computed } from 'vue';
import InputField from './inputField.vue';
import CaptchaField from '../captchaField.vue';
import { sendOtpCode, verifyOtpCode, getCaptchaCode } from '@/api/user';
import { useI18n } from 'vue-i18n';
import MainButton from '../../../components/common/mainButton.vue';
import StatusPopup from '@/components/common/statusPopup.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'sendOtpPopup',
  props: {
    verificationData: {
        type: Object,
        default: () => ({})
    },
    phoneNumber: {
        type: String,
        default: ''
    },
    uuid: {
        type: String,
        default: ''
    },
    emailVerified: {
        type: Boolean,
        default: false
    },
    phoneVerified: {
        type: Boolean,
        default: false
    },
    stepType: {
        type: String,
        default: 'SMS'
    }
},
  emits: ['verified', 'close'],
  setup(__props, { emit: __emit }) {

const { t } = useI18n();
const statusRef = ref()
const isSuccess = ref(false)
const toastContent = ref('')
const smsOTPRef = ref()
const btnLoading = ref(false)
const props = __props;

const emit = __emit;

const show = ref(true);
const selectedMethod = ref('');
const contactValue = ref('');
const phoneNumberDisplay = ref(props.phoneNumber);
const otpCaptcha = ref('');
const otpValue = ref('');
const captchaData = ref<any>(null);
const updateOtpCaptcha = (val: string) => {
    otpCaptcha.value = val;
};
const contactType = computed(() => {
  if (props.stepType === 'phone') {
    return props.verificationData.whatsappVerified ? 'WHATSAPP' : 'SMS';
  }
  return 'EMAIL';
});
const areaCode = ref('55'); // Brazil area code

const pendingMethods = ref<string[]>([]);
const currentMethodIndex = ref(0);

const getCaptcha = () => {
    getCaptchaCode().then(res => {
        captchaData.value = res.data;
    });
};

watch(() => props.phoneNumber, (newVal) => {
    phoneNumberDisplay.value = newVal;
});

// Initialize selected method based on verification data
watch(() => props.verificationData, (data) => {
    const methods: string[] = [];
    if (data?.smsVerified) methods.push('sms');
    if (data?.whatsappVerified) methods.push('WHATSAPP');
    if (data?.emailVerified) methods.push('email');
    pendingMethods.value = methods;
    currentMethodIndex.value = 0;
    if (methods.length > 0) {
        selectedMethod.value = methods[0];
    }
    getCaptcha();
}, { immediate: true });

const sendOtp = () => {
    if (!selectedMethod.value){
        smsOTPRef.value?.loadingFalse();
        return;
    }
    if (selectedMethod.value === 'email' && !contactValue.value){
        smsOTPRef.value?.loadingFalse();
        return;
    }
    const captcha = otpCaptcha.value?.trim();
    if (!captcha) {
        smsOTPRef.value?.loadingFalse();
        return;
    }
    const contact = props.stepType === 'email' ? props.verificationData.email : props.verificationData.phoneNumber;
    const params = {
        uuid: captchaData.value?.uuid,
        fpCaptchaType: 'CAPTCHA-FP-step-2',
        captcha: otpCaptcha.value.trim(),
        forgetPasswordCaptcha: captchaData.value?.forgetPasswordCaptchaEnabled,
        contact: contact,
        contactType: contactType.value,
        areaCode: areaCode.value,
        fpUuid: props.verificationData.fpUuid
    };

    sendOtpCode(params)
        .then(res => {
            if (res.code === 200) {
                smsOTPRef.value?.loadingFalse();
                smsOTPRef.value?.startCountdown();
                showSuccess(res.msg);
            } else {
                getCaptcha();
                smsOTPRef.value?.loadingFalse();
                showError(res.msg);
            }
        })
        .catch(err => {
            showError(err);
            getCaptcha();
            smsOTPRef.value?.loadingFalse();
        });
};

const verifyOtp = () => {
    if (!otpValue.value || !otpValue.value.trim()) {
        return;
    }
    const contact = props.stepType === 'email' ? props.verificationData.email : props.verificationData.phoneNumber;
    const params = {
        contact: contact,
        contactType: contactType.value,
        otpCode: otpValue.value.trim(),
        areaCode: areaCode.value,
        fpUuid: props.verificationData.fpUuid
    };
    btnLoading.value = true;
    verifyOtpCode(params)
        .then(res => {
            if (res.code === 200) {
                showSuccess(res.msg);
                setTimeout(() => {
                    emit('verified', props.stepType);
                }, 1000);
            } else {
                showError(res.msg);
            }
            resendOtp();
            btnLoading.value = false;
        })
        .catch(err => {
            console.error('Verify OTP error:', err);
            btnLoading.value = false;
            showError(err);
            // alert('OTP verification failed. Please try again.');
        });
};

const resendOtp = () => {
    otpValue.value = '';
    otpCaptcha.value = '';
    otpValue.value = '';
    getCaptcha();
};

const mask = (v: string) =>
  v?.includes('@')
    ? v.replace(/^(.{1,2}).*(@.*)$/, (_, a, b) => a + '*'.repeat(Math.max(v.split('@')[0].length - a.length, 1)) + b)
    : v?.replace(/^(.{3}).*(.{4})$/, (_, a, b) => a + '*'.repeat(v.length - 7) + b) || '';

const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}

const showSuccess = (message: string) => {
    toastContent.value = message;
    isSuccess.value = true;
    statusRef.value.open()
}

const smsOTPChange = (value: string) => {
    // emits('smsOTPChange', value)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (show.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('common.getCode')), 1),
            _createElementVNode("p", _hoisted_4, [
              _createTextVNode(_toDisplayString(_ctx.$t('common.codeWillSend')) + " ", 1),
              (__props.stepType == 'email')
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(mask(props.verificationData.email)), 1))
                : _createCommentVNode("", true),
              (__props.stepType == 'phone')
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(mask(props.verificationData.phoneNumber)), 1))
                : _createCommentVNode("", true)
            ]),
            _createVNode(CaptchaField, {
              "captcha-img": captchaData.value?.img ? 'data:image/png;base64,' + captchaData.value.img : '',
              onValueChanged: updateOtpCaptcha,
              onUpdateCaptcha: getCaptcha
            }, null, 8, ["captcha-img"]),
            _createVNode(InputField, {
              modelValue: otpValue.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((otpValue).value = $event)),
              onValueChanged: smsOTPChange,
              ref_key: "smsOTPRef",
              ref: smsOTPRef,
              labelText: _ctx.$t('loginRegister.smsCode'),
              fieldType: "number",
              isOTP: true,
              onGetOtp: sendOtp
            }, null, 8, ["modelValue", "labelText"]),
            _createVNode(MainButton, {
              title: _ctx.$t('common.verificationOTP'),
              radius: "5px !important",
              activeStatus: otpCaptcha.value.length > 0 && otpValue.value.length > 0,
              onClick: verifyOtp,
              "btn-padding": "30px !important",
              style: {"margin":"2rem 0 1rem"},
              isBtnLoading: btnLoading.value
            }, null, 8, ["title", "activeStatus", "isBtnLoading"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(StatusPopup, {
      ref_key: "statusRef",
      ref: statusRef,
      "is-show-success": isSuccess.value,
      content: toastContent.value
    }, null, 8, ["is-show-success", "content"])
  ], 64))
}
}

})